import React, { Fragment ,useEffect,useRef} from 'react';
import { Dialog, Transition,TransitionChild } from '@headlessui/react';
import { toPng } from 'html-to-image';
import html2canvas from 'html2canvas';
import { jsPDF } from 'jspdf';

import { jwtDecode } from 'jwt-decode';
import axios from 'axios';
import { toast } from 'react-toastify';

import invoice from '../../Assets/img/invoice1.png';
import { useSearch } from 'rsuite/esm/internals/Picker';

const InvoiceModal = ({
  isOpen,
  setIsOpen,
  invoiceInfo,
  items,
  // onAddNextInvoice,
}) => {
  const divRef = useRef();
  const token = localStorage.getItem('token');
  const decodedToken = jwtDecode(token);
  const userId ={userID: decodedToken.id};

  const closeModal = () => {
    setIsOpen(false);
  }

  const addNextInvoiceHandler = () => {
    setIsOpen(false);
    // onAddNextInvoice();
  };

  //get total price
  const totalSum = items.reduce((accumulator, item) => {
    return accumulator + item.price * item.qty;
  }, 0);

  const SaveAsPDFHandler = () => {
    saveInvoieData();
    const dom = document.getElementById('print');
    toPng(dom)
      .then((dataUrl) => {
        const img = new Image();
        img.crossOrigin = 'anonymous';
        img.src = dataUrl;
        img.onload = () => {
          // Initialize the PDF.
          const pdf = new jsPDF({
            orientation: 'portrait',
            unit: 'in',
            format: [8.27, 11.69],
          });

          // Define reused data
          const imgProps = pdf.getImageProperties(img);
          const imageType = imgProps.fileType;
          const pdfWidth = pdf.internal.pageSize.getWidth();

          // Calculate the number of pages.
          const pxFullHeight = imgProps.height;
          const pxPageHeight = Math.floor((imgProps.width * 8.5) / 5.5);
          const nPages = Math.ceil(pxFullHeight / pxPageHeight);

          // Define pageHeight separately so it can be trimmed on the final page.
          let pageHeight = pdf.internal.pageSize.getHeight();

          // Create a one-page canvas to split up the full image.
          const pageCanvas = document.createElement('canvas');
          const pageCtx = pageCanvas.getContext('2d');
          pageCanvas.width = imgProps.width;
          pageCanvas.height = pxPageHeight;

          for (let page = 0; page < nPages; page++) {
            // Trim the final page to reduce file size.
            if (page === nPages - 1 && pxFullHeight % pxPageHeight !== 0) {
              pageCanvas.height = pxFullHeight % pxPageHeight;
              pageHeight = (pageCanvas.height * pdfWidth) / pageCanvas.width;
            }
            // Display the page.
            const w = pageCanvas.width;
            const h = pageCanvas.height;
            pageCtx.fillStyle = 'white';
            pageCtx.fillRect(0, 0, w, h);
            pageCtx.drawImage(img, 0, page * pxPageHeight, w, h, 0, 0, w, h);

            // Add the page to the PDF.
            if (page) pdf.addPage();

            const imgData = pageCanvas.toDataURL(`image/${imageType}`, 1);
            pdf.addImage(imgData, imageType, 0, 0, pdfWidth, pageHeight);
          }
          // Output / Save
          pdf.save(`invoice-${String(invoiceInfo.invoiceNumber).padStart(6, '0')}.pdf`);
        };
      })
      .catch((error) => {
        console.error('oops, something went wrong!', error);
      });
  };

  // const SaveAsPDFHandler = async () => {
  //   const element = divRef.current;
  //   const canvas = await html2canvas(element);
  //   const imgData = canvas.toDataURL('image/png');
  //   const pdf = new jsPDF();

  //   pdf.addImage(imgData, 'PNG', 10, 10, 190, 0); // Adjust width and height as needed
  //   pdf.save("div-content.pdf");
  // };

  // const SaveAsPDFHandler = async () => {
  //   const element = divRef.current;

  //   // Render the div as a canvas
  //   const canvas = await html2canvas(element, { scale: 2 }); // Increase scale for better quality

  //   // Convert the canvas to an image
  //   const imgData = canvas.toDataURL('image/png');

  //   // Create a PDF with A4 dimensions in portrait mode (mm)
  //   const pdf = new jsPDF('portrait', 'mm', 'a4'); // A4 is 210x297 mm

  //   // Calculate image dimensions to fit A4
  //   const imgWidth = 210; // A4 width in mm
  //   const imgHeight = (canvas.height * imgWidth) / canvas.width; // Maintain aspect ratio

  //   // If the image height is greater than the page height, split it into multiple pages
  //   let heightLeft = imgHeight;
  //   let position = 0;
  //   const pageHeight = pdf.internal.pageSize.height;

  //   if (heightLeft >= pageHeight) {
  //     // Split the image into multiple pages
  //     while (heightLeft >= 0) {
  //       pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
  //       heightLeft -= pageHeight;
  //       position -= pageHeight; // Move position for the next page
  //       if (heightLeft >= 0) {
  //         pdf.addPage(); // Add a new page if there's more content
  //       }
  //     }
  //   } else {
  //     // If the image fits on one page
  //     pdf.addImage(imgData, 'PNG', 0, 0, imgWidth, imgHeight);
  //   }

  //   // Save the PDF
  //   pdf.save("div-content.pdf");
  // };


  const saveInvoieData = async() => {
 
    try {
        const POCBaseUrl = process.env.REACT_APP_GXIN_POC_BASE_URL;

        if (!POCBaseUrl) {
            throw new Error('API base URL is not defined');
        }
        const response = await axios.post(`${POCBaseUrl}/invoices/create`, {invoiceInfo},
            {
                headers: {
                  "Content-Type": "application/json", // Specify content type
                  Authorization: `Bearer ${token}`, // Include the token
                },
              }
        )
        .then(response=>{
            console.log(response.data.message);
            toast.success('Invoice created successfully!', {
                className: 'centered-toast-success',
                bodyClassName: 'centered-body',
                autoClose: 2000,
                hideProgressBar: true,
                closeButton: false,
                pauseOnHover: false,
                // draggable: true,
                pauseOnFocusLoss: true
              });
            setIsOpen(false);
        })
        .catch(error=>{
            console.error("There was an error", error);
        })
    } catch (error) {
        console.error('Error sending message:', error);
    }
  }


  return (
    <Transition appear show={isOpen} as={Fragment}>
        {/* <div onClick={handleWriteData}>aaa</div> */}
        <Dialog
        as="div"
        className="fixed inset-0 z-10 overflow-y-auto"
        onClose={closeModal}
      >
        <div className="min-h-screen px-4 text-center">

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="inline-block h-screen align-middle"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <TransitionChild
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <div className="my-8 min-w-[794px] inline-block w-full max-w-md transform overflow-hidden rounded-lg bg-white text-left align-middle shadow-xl transition-all">
              {/* <div className="p-4 text-[black]" id="print" ref={divRef}> */}
              <div className="p-7 text-[black]" id="print" >
                <div className='text-left text-[20px] pt-10 pb-3 font-bold'>{invoiceInfo.businessName}</div>
                <div className='flex justify-between'>
                  <div className='text-left font-bold'>
                      <div className='text-[1.005rem]'>{invoiceInfo.senderState},{invoiceInfo.senderState1}</div>
                      <div className='text-[1.005rem]'>{invoiceInfo.postalCode}</div>
                      <div className='text-[1.005rem]'>Phone: {invoiceInfo.senderPhone}</div>
                      <div className='pt-2'>{invoiceInfo.irishDate}</div>
                  </div>
                </div>
                <div className='flex justify-between mt-5 w-full'>
                      <div className='flex flex-col justify-end pb-2'>
                          <span>Invoice No. {String(invoiceInfo.invoiceNumber).padStart(6, '0')}</span>
                      </div>
                      <div className='text-[2rem] text-right font-bold'>
                          Invoice
                      </div>
                </div>
                <div className='flex justify-center'>
                  <div className='border-t border-[black] mt-4 w-[98%]'></div>
                </div>

                <div className='mt-5'>
                  <div className='font-bold'>
                      BILL TO:
                  </div>
                  <div className='mt-3'>Name: &nbsp; {invoiceInfo.customerName}</div>
                  <div>Address:&nbsp; {invoiceInfo.address1},{invoiceInfo.address2},{invoiceInfo.address3}</div>
                </div>

                <div className="mt-6">
                  <div className='h-[550px]'>
                    <div className='border-t border-black border-l border-black border-b border-black h-[510px]'>
                      <table className="w-full text-left">
                        <thead>
                          <tr  className='border-b border-black'>
                            <th className='border-r border-black p-1 text-center'>QTY</th>
                            <th className="text-center border-r border-black p-1 text-center">DESCRIPTION</th>
                            <th className="border-r border-black p-1 text-center">UNIT PRICE</th>
                            <th className="text-center border-r border-black p-1 ">VAT</th>
                            <th className="text-center border-r border-black p-1">TOTAL</th>
                          </tr>
                        </thead>
                        <tbody>
                          {items.map((item) => (
                            <tr key={item.id}>
                              <td className="min-w-[50px] text-center border-r border-black">
                                {item.qty}
                              </td>
                              <td className="w-full border-r border-black pl-1">{item.name}</td>
                              <td className="min-w-[100px] text-right border-r border-black pr-1">
                                {Number(item.price).toFixed(2)}
                              </td>
                              <td className="min-w-[90px] text-right border-r border-black pr-1">
                                {Number(invoiceInfo.tax).toFixed(2)}
                              </td>
                              <td className="min-w-[90px] text-right border-r border-black pr-1">
                                {Number(item.price * item.qty).toFixed(2)}
                              </td>
                            </tr>
                          ))}
                          {Array.from({ length: 24-items.length }, (_, index) => (
                            <tr key={index}>
                              <td className="min-w-[50px] text-center border-r border-black">
                                <span className='invisible'>aaa</span>
                              </td>
                              <td className="w-full border-r border-black">
                                <span className='invisible'>aaa</span>
                              </td>
                              <td className="min-w-[80px] text-right border-r border-black">
                                <span className='invisible'>aaa</span>
                              </td>
                              <td className="min-w-[90px] text-right border-r border-black">
                                <span className='invisible'>aaa</span>
                              </td>
                              <td className="min-w-[90px] text-right border-r border-black">
                                <span className='invisible'>aaa</span>
                              </td>
                            </tr>
                          ))}
                            <tr>
                              <td className="min-w-[50px] text-center">
                                <span className='invisible'>aaa</span>
                              </td>
                              <td className="w-full">
                                <span className='invisible'>aaa</span>
                              </td>
                              <td className="min-w-[80px] text-right">
                                <span className='invisible'>aaa</span>
                              </td>
                              <td className="min-w-[90px] text-right border-r border-black border-l border-black border-b border-black">
                                <div className='w-full h-[40px] items-center flex justify-center'>
                                   <div>
                                      TOTAL
                                   </div>
                                </div>
                              </td>
                              <td className="min-w-[90px] text-right border-r border-black border-l border-black border-b border-black">
                                <div className='w-full pr-1'>{Number(totalSum).toFixed(2)}</div>
                              </td>
                            </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div className='w-full pt-5'>
                      <div>
                        All invoices are due for payment 30 days from date of invoice.
                      </div>
                      <div className='flex justify-center'>
                        <div className='border-t border-[black] mt-2 w-[98%]'></div>
                      </div>
                      <div className='mt-5'>
                        Payment Information
                      </div>
                      <div className='mt-5'>
                          <div>AIB Main Street, Midleton, Co. Cork, Ireland IBAN: IE</div>
                          <div>75 AIBK 9341 2707 2631 87</div>
                      </div>
                      <div className='text-[11px] font-bold mt-10'>Director: Michael McPadden Company Registration No. 123456 VAT Registration No. 123456</div>
                  </div>

                  {/* <div className="mt-4 flex flex-col items-end space-y-2">
                    <div className="flex w-full justify-between border-t border-black/10 pt-2">
                      <span className="font-bold">Subtotal:</span>
                      <span>€{invoiceInfo.subtotal.toFixed(2)}</span>
                    </div>
                    <div className="flex w-full justify-between">
                      <span className="font-bold">Discount:</span>
                      <span>€{invoiceInfo.discountRate.toFixed(2)}</span>
                    </div>
                    <div className="flex w-full justify-between">
                      <span className="font-bold">Tax:</span>
                      <span>€{invoiceInfo.taxRate.toFixed(2)}</span>
                    </div>
                    <div className="flex w-full justify-between border-t border-black/10 py-2">
                      <span className="font-bold">Total:</span>
                      <span className="font-bold">
                        €
                        {invoiceInfo.total % 1 === 0
                          ? invoiceInfo.total
                          : invoiceInfo.total.toFixed(2)}
                      </span>
                    </div>
                  </div> */}
                </div>
              </div>
              <div className="mt-4 flex space-x-2 px-4 pb-6">
                <button
                  className="flex w-full items-center justify-center space-x-1 rounded-md border border-blue-500 py-2 text-sm text-blue-500 shadow-sm hover:bg-blue-500 hover:text-white"
                  onClick={SaveAsPDFHandler}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    className="h-4 w-4"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth={2}
                      d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
                    />
                  </svg>
                  <span>Create and Download</span>
                </button>
                <button
                  onClick={addNextInvoiceHandler}
                  className="flex w-full items-center justify-center space-x-1 rounded-md bg-blue-500 py-2 text-sm text-white shadow-sm hover:bg-blue-600"
                >
                  <span>Close</span>
                </button>
              </div>
            </div>
          </TransitionChild>
        </div>
      </Dialog>
    </Transition>
  );
};

export default InvoiceModal;
